export enum FileType {
  PDF = '.pdf,application/pdf',
  JPG = '.jpg,.jpeg,image/jpeg',
  PNG = '.png,image/png',
  CSV = '.csv,text/csv',
}
